"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/***************************************************************************************************
 *
 *       @file ./api-routes.ts
 *
 *       Default API request routes
 *       Should be overridden by provided config in instantiating JVLNS
 *
 */
var env_var_helpers_1 = require("env-var-helpers");
var envSubdomainExt = env_var_helpers_1.releaseEnvShort === 'prod' ? '' : env_var_helpers_1.releaseEnvShort + '.';
var protocol = "https";
var hostname = "canimmunize.ca";
var syncDomain = protocol + "://sync." + envSubdomainExt + hostname;
var syncAPI = syncDomain + "/api/v2";
// const syncAPI = `http://localhost:8082/api/v2`;
var syncAPIProd = protocol + "://sync." + hostname + "/api/v2";
var settingsDomain = syncAPI + "/settings";
var adminApiBaseUrl = protocol + "://admin." + envSubdomainExt + hostname + "/api/v2";
var apiRoutesFactory = function (env) {
    if (env === void 0) { env = envSubdomainExt; }
    // prettier-ignore
    return {
        'banners': { method: "GET", url: adminApiBaseUrl + "/banners" },
        'cities': { method: "GET", url: adminApiBaseUrl + "/cities" },
        'configMain': { method: "GET", url: adminApiBaseUrl + "/config/main" },
        'diseases': { method: "GET", url: adminApiBaseUrl + "/diseases" },
        'outbreaks': { method: "GET", url: adminApiBaseUrl + "/outbreaks" },
        'schedules': { method: "GET", url: adminApiBaseUrl + "/schedules" },
        'vaccines': { method: "GET", url: adminApiBaseUrl + "/vaccines" },
        'phu': { method: "GET", url: adminApiBaseUrl + "/phu" },
        'content': { method: "GET", url: adminApiBaseUrl + "/content" },
        /** Sync record data **/
        'record-ids': { method: "get", url: syncAPI + "/record-ids" },
        'sync': { method: "post", url: syncAPI + "/sync" },
        /** Login / Logout **/
        'login': { method: "post", url: syncAPI + "/login" },
        'login-mfa': { method: "post", url: syncAPI + "/login-mfa" },
        'logout': { method: "get", url: syncAPI + "/logout" },
        /** Account settings **/
        'settings/update-account': { method: "post", url: settingsDomain + "/update-account" },
        'settings/change-password': { method: "post", url: settingsDomain + "/change-password" },
        'settings/change-email': { method: "post", url: settingsDomain + "/change-email" },
        'change-phone': { method: "post", url: settingsDomain + "/change-phone" },
        /** Account creation & deletion **/
        'signup': { method: "post", url: syncAPI + "/signup" },
        'delete/request': { method: "post", url: syncAPI + "/delete/request" },
        'delete/cancel': { method: "post", url: syncAPI + "/delete/cancel" },
        /** Determine if given email has an associated account **/
        'check-email-availability': { method: "post", url: syncAPI + "/check-email-availability" },
        /** Account unlock **/
        'unlock-account': { method: "post", url: syncAPI + "/unlock-account" },
        'resend-unlock-account-email': { method: "post", url: syncAPI + "/resend-unlock-account-email" },
        /** Account verification **/
        'confirm': { method: "get", url: syncAPI + "/confirm" },
        'verify-phone': { method: "post", url: settingsDomain + "/verify-phone" },
        'resend-verify-phone': { method: "get", url: settingsDomain + "/resend-verify-phone" },
        'resend-verify-email': { method: "post", url: syncAPI + "/resend-verify-email" },
        /** Password reset **/
        // Note: Duplicates are not a mistake - all 3 are handled by the same endpoint
        'forgot-password': { method: "post", url: syncAPI + "/forgot-password" },
        'reset-password': { method: "put", url: syncAPI + "/forgot-password" },
        'get-reset-password-page': { method: "post", url: syncAPI + "/forgot-password" },
    };
};
/**
 * Environment-specific API routes
 */
exports.apiRoutes = apiRoutesFactory(envSubdomainExt);
/**
 * Production API routes (for downloading data to local JSON files)
 */
exports.apiRoutesProd = apiRoutesFactory('');
//# sourceMappingURL=api-routes.js.map